export default __webpack_public_path__ + "static/Inter-Italic-cb10ffd7684cd9836a055a6afad8ffcc.woff2";